export const statesOfIndia = [
  { code: 1, name: 'Andaman and Nicobar Islands', esicState: 'Andaman and Nicobar' },
  { code: 2, name: 'Andhra Pradesh', esicState: 'Andhra Pradesh' },
  { code: 3, name: 'Arunachal Pradesh', esicState: 'Arunachal Pradesh' },
  { code: 4, name: 'Assam', esicState: 'Assam' },
  { code: 5, name: 'Bihar', esicState: 'Bihar' },
  { code: 6, name: 'Chandigarh', esicState: 'Chandigarh' },
  { code: 7, name: 'Chhattisgarh', esicState: 'Chhattisgarh' },
  { code: 8, name: 'Dadra and Nagar Haveli', esicState: 'Dadra and Nagar Haveli' },
  { code: 9, name: 'Daman and Diu', esicState: 'Daman and Diu' },
  { code: 10, name: 'Delhi', esicState: 'Delhi' },
  { code: 11, name: 'Goa', esicState: 'Goa' },
  { code: 12, name: 'Gujarat', esicState: 'Gujarat' },
  { code: 13, name: 'Haryana', esicState: 'Haryana' },
  { code: 14, name: 'Himachal Pradesh', esicState: 'Himachal Pradesh' },
  { code: 15, name: 'Jammu and Kashmir', esicState: 'Jammu and Kashmir' },
  { code: 16, name: 'Jharkhand', esicState: 'Jharkhand' },
  { code: 17, name: 'Karnataka', esicState: 'Karnataka' },
  { code: 18, name: 'Kerala', esicState: 'Kerala' },
  { code: 19, name: 'Lakshadweep', esicState: 'Lakshadweep' },
  { code: 20, name: 'Madhya Pradesh', esicState: 'Madhya Pradesh' },
  { code: 21, name: 'Maharashtra', esicState: 'Maharashtra' },
  { code: 22, name: 'Manipur', esicState: 'Manipur' },
  { code: 23, name: 'Meghalaya', esicState: 'Meghalaya' },
  { code: 24, name: 'Mizoram', esicState: 'Mizoram' },
  { code: 25, name: 'Nagaland', esicState: 'Nagaland' },
  { code: 26, name: 'Odisha', esicState: 'Odisha' },
  { code: 27, name: 'Puducherry', esicState: 'Puducherry' },
  { code: 28, name: 'Punjab', esicState: 'Punjab' },
  { code: 29, name: 'Rajasthan', esicState: 'Rajasthan' },
  { code: 30, name: 'Sikkim', esicState: 'Sikkim' },
  { code: 31, name: 'Tamil Nadu', esicState: 'Tamilnadu' },
  { code: 37, name: 'Tamil Nadu (Tiruchirappalli)', esicState: 'Tamilnadu' },
  { code: 32, name: 'Telangana', esicState: 'Telangana' },
  { code: 33, name: 'Tripura', esicState: 'Tripura' },
  { code: 34, name: 'Uttar Pradesh', esicState: 'Uttar Pradesh' },
  { code: 35, name: 'Uttarakhand', esicState: 'Uttarakhand' },
  { code: 36, name: 'West Bengal', esicState: 'West Bengal' },
];
